<div class="container">

    <div class="stats-cards">

        <div class="stats-card" (click)="onStatCardClick('Teams')">
            <div class="card-title">Teams Sync</div>
            <div class="card-subtitle">Last 7 days</div>
            <div class="stats">
            <div class="stat success">
                <span class="stat-value">{{ teamsSuccessCount }}</span>
                <span class="stat-label">Successful</span>
            </div>

            <div class="stat failed">
                <span class="stat-value">{{ teamsFailCount }}</span>
                <span class="stat-label">Failed</span>
            </div>
            </div>
        </div>

        <div class="stats-card" (click)="onStatCardClick('Sites')">
            <div class="card-title">Sites Sync</div>
            <div class="card-subtitle">Last 7 days</div>
            <div class="stats">
            <div class="stat success">
                <span class="stat-value">{{ sitesSuccessCount }}</span>
                <span class="stat-label">Successful</span>
            </div>

            <div class="stat failed">
                <span class="stat-value">{{ sitesFailCount }}</span>
                <span class="stat-label">Failed</span>
            </div>
            </div>
        </div>

        <div class="stats-card" (click)="onStatCardClick('Ris')">
            <div class="card-title">RIS Sync</div>
            <div class="card-subtitle">Last 7 days</div>
            <div class="stats">
            <div class="stat success">
                <span class="stat-value">{{ risSuccessCount }}</span>
                <span class="stat-label">Successful</span>
            </div>

            <div class="stat failed">
                <span class="stat-value">{{ risFailCount }}</span>
                <span class="stat-label">Failed</span>
            </div>
            </div>
        </div>

        <div class="stats-card" (click)="onStatCardClick('Bookings')">
            <div class="card-title">Bookings Sync</div>
            <div class="card-subtitle">Last 7 days</div>
            <div class="stats">
            <div class="stat success">
                <span class="stat-value">{{ bookingsSuccessCount }}</span>
                <span class="stat-label">Successful</span>
            </div>

            <div class="stat failed">
                <span class="stat-value">{{ bookingsFailCount }}</span>
                <span class="stat-label">Failed</span>
            </div>
            </div>
        </div>

        <div class="stats-card" (click)="onStatCardClick('Governance')">
            <div class="card-title">Governance Service</div>
            <div class="card-subtitle">Last 7 days</div>
            <div class="stats">
            <div class="stat success">
                <span class="stat-value">{{ governanceSuccessCount }}</span>
                <span class="stat-label">Successful</span>
            </div>

            <div class="stat failed">
                <span class="stat-value">{{ governanceFailCount }}</span>
                <span class="stat-label">Failed</span>
            </div>
            </div>
        </div>

        <div class="stats-card" (click)="onStatCardClick('newResources')">
            <div class="card-title">New Resources</div>
            <div class="card-subtitle">Last 7 days</div>
            <div class="stats">
            <div class="stat success">
                <span class="stat-value">{{ newResourcesSuccessCount }}</span>
                <span class="stat-label">Successful</span>
            </div>

            <div class="stat failed">
                <span class="stat-value">{{ newResourcesFailCount }}</span>
                <span class="stat-label">Failed</span>
            </div>
            </div>
        </div>

        <div class="stats-card" (click)="onStatCardClick('extensions')">
            <div class="card-title">Lifecycle Extensions</div>
            <div class="card-subtitle">Last 7 days</div>
            <div class="stats">
            <div class="stat success">
                <span class="stat-value">{{ extensions?.length }}</span>
                <span class="stat-label">Successful</span>
            </div>
            </div>
        </div>

        <div class="stats-card" (click)="onStatCardClick('ownerDeletions')">
            <div class="card-title">Deletions by Owners</div>
            <div class="card-subtitle">Last 7 days</div>
            <div class="stats">
            <div class="stat success">
                <span class="stat-value">{{ ownerDeletions?.length }}</span>
                <span class="stat-label">Successful</span>
            </div>
            </div>
        </div>

        <div class="stats-card" (click)="onStatCardClick('endOfLifeDeletions')">
            <div class="card-title">Deletions at End of Life</div>
            <div class="card-subtitle">Last 7 days</div>
            <div class="stats">
            <div class="stat success">
                <span class="stat-value">{{ endOfLifeDeletions?.length }}</span>
                <span class="stat-label">Successful</span>
            </div>
            </div>
        </div>
    </div>

    <div class="filter-container">
        <form [formGroup]="filterMenu" class="filterOption">
          <mat-form-field class="filterMenu">
            <mat-label>{{ 'Startdate' }}</mat-label>
            <input
            matInput
            [matDatepicker]="startDatePicker"
            formControlName="startDate"
            (dateChange)="filterSearch('startDate')"
            [min]="minDate"
            [max]="maxDate"
            />
            <mat-datepicker-toggle
            matIconSuffix
            [for]="startDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="filterMenu">
            <mat-label>{{ 'Enddate' }}</mat-label>
            <input
            matInput
            [matDatepicker]="endDatePicker"
            formControlName="endDate"
            (dateChange)="filterSearch('endDate')"
            [min]="minDate"
            [max]="maxDate"
            />
            <mat-datepicker-toggle
            matIconSuffix
            [for]="endDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="filterMenu">
                <mat-label>{{ 'Entity ID' }}</mat-label>
                <input
                    matInput
                    id="entityId"
                    type="text"
                    formControlName="entityId"
                    (keydown.enter)="filterSearch('entityId')"
                    #input
                />
                <button
                    matSuffix
                    mat-icon-button
                    aria-label="Search"
                    (click)="filterSearch('entityId')"
                >
                    <img
                    src="../../assets/icons/Search--Streamline-Ultimate.svg"
                    alt="Search"
                    />
                </button>
            </mat-form-field>

            <mat-form-field class="filterMenu">
                <mat-label>{{ 'Actor ID' }}</mat-label>
                <input
                    matInput
                    id="actorId"
                    type="text"
                    formControlName="actorId"
                    (keydown.enter)="filterSearch('actorId')"
                    #input
                />
                <button
                    matSuffix
                    mat-icon-button
                    aria-label="Search"
                    (click)="filterSearch('actorId')"
                >
                    <img
                    src="../../assets/icons/Search--Streamline-Ultimate.svg"
                    alt="Search"
                    />
                </button>
            </mat-form-field>

            <mat-form-field class="filterMenu">
                <mat-label>{{ 'Run ID' }}</mat-label>
                <input
                    matInput
                    id="runId"
                    type="text"
                    formControlName="runId"
                    (keydown.enter)="filterSearch('runId')"
                    #input
                />
                <button
                    matSuffix
                    mat-icon-button
                    aria-label="Search"
                    (click)="filterSearch('runId')"
                >
                    <img
                    src="../../assets/icons/Search--Streamline-Ultimate.svg"
                    alt="Search"
                    />
                </button>
            </mat-form-field>

         <mat-form-field class="filterMenu">
                <mat-label>{{ 'Component' }}</mat-label>
                <mat-select
                    id="component"
                    formControlName="component"
                    (selectionChange)="filterEvent('component',$event)"
                >
                    <mat-option [value]="">All</mat-option>
                    <mat-option
                        *ngFor="let component of components"
                        [value]="component"
                    >
                        {{ component }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filterMenu">
                <mat-label>{{ 'Action' }}</mat-label>
                <mat-select
                    id="action"
                    formControlName="action"
                    (selectionChange)="filterEvent('action',$event)"
                >
                    <mat-option [value]="">All</mat-option>
                    <mat-option
                        *ngFor="let action of actions"
                        [value]="action"
                    >
                        {{ action }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filterMenu">
                <mat-label>{{ 'Actor Type' }}</mat-label>
                <mat-select
                    id="actorType"
                    formControlName="actorType"
                    (selectionChange)="filterEvent('actorType',$event)"
                >
                    <mat-option [value]="">All</mat-option>
                    <mat-option value="User">User</mat-option>
                    <mat-option value="System">System</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="filterMenu">
                <mat-label>{{ 'Entity Type' }}</mat-label>
                <mat-select
                    id="entityType"
                    formControlName="entityType"
                    (selectionChange)="setOutcomes();filterEvent('entityType',$event)"
                >
                    <mat-option [value]="">All</mat-option>
                    <mat-option
                        *ngFor="let entityType of entityTypes"
                        [value]="entityType"
                    >
                        {{ entityType }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="inline-info">
              <mat-form-field class="filterMenu">
                  <mat-label>{{ 'Outcome' }}</mat-label>
                  <mat-select
                      id="outcome"
                      formControlName="outcome"
                      [disabled]="!filterMenu.get('entityType')?.value"
                      (selectionChange)="filterEvent('outcome',$event)"
                  >
                      <mat-option [value]="">All</mat-option>
                      <mat-option
                          *ngFor="let outcome of outcomes"
                          [value]="outcome"
                      >
                          {{ outcome }}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
              <i>
                <img
                  class="infobutton"
                  src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
                  alt="Info"
                  [matTooltip]="'You have to select an Entity Type to select an Outcome.'"
                  matTooltipClass="newline-matTooltip"
                />
              </i>
            </div>
            <mat-form-field class="filterMenu">
                <mat-label>{{ 'Severity' }}</mat-label>
                <mat-select
                    multiple
                    id="severity"
                    formControlName="severity"
                    (selectionChange)="filterEvent('severity',$event)"
                >
                    <mat-option value="Info">Info</mat-option>
                    <mat-option value="Warning">Warning</mat-option>
                    <mat-option value="Error">Error</mat-option>
                </mat-select>
            </mat-form-field>

            <button
              mat-flat-button
              color="primary"
              class="filterMenu"
              (click)="clearFilter();getUnfilteredData()"
              >
              {{ 'Clear' }}
            </button>
        </form>
    </div>    

  <div class="table">
    <div class="mat-elevation-z8">
      <table
        mat-table
        [dataSource]="tableDataSource"
        matSort
        class="mat-elevation-z8"
        multiTemplateDataRows
      >
        <ng-container matColumnDef="occurredAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'Occured At' }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span [matTooltip]="element.occurredAt">
              {{ element.occurredAt | date:'dd.MM.yyyy HH:mm' }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="component">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Component' }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.component }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actorType">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Actor Type' }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.actorType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Action' }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.action }}
          </td>
        </ng-container>

        <ng-container matColumnDef="entityId">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Entity ID' }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.entityId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="entityDisplay">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'Entity Display' }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.entityDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="runId">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Run ID' }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.runId || "-"}}
          </td>
        </ng-container>

        <ng-container matColumnDef="outcome">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Outcome' }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.outcome }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
  <td
    mat-cell
    *matCellDef="let element"
    [attr.colspan]="tableColumns.length"
  >
    <div
      class="expanded-detail"
      [class.expanded]="expandedElement === element"
    >
      <div class="detail-content">

        <div class="detail-item">
          <strong>Event ID</strong>
          <span>{{ element.eventId }}</span>
        </div>

        <div class="detail-item">
          <strong>Application</strong>
          <span>{{ element.application }}</span>
        </div>

        <div class="detail-item">
          <strong>Actor ID</strong>
          <span>{{ element.actorId }}</span>
        </div>

        <div class="detail-item">
          <strong>Actor Displayname</strong>
          <span>{{ element.actorDisplay || "-"}}</span>
        </div>

        <div class="detail-item">
          <strong>Severity</strong>
          <span>{{ element.severity }}</span>
        </div>

        <div class="detail-item">
          <strong>Correlation ID</strong>
          <span>{{ element.correlationId }}</span>
        </div>

        <div class="detail-item">
          <strong>Message</strong>
          <span>{{ element.message }}</span>
        </div>

      </div>
    </div>
  </td>
</ng-container>

        <tr
            mat-header-row
            *matHeaderRowDef="tableColumns; sticky: true"
            ></tr>

            <tr
            mat-row
            *matRowDef="let row; columns: tableColumns"
            class="element-row"
            [class.expanded-row]="expandedElement === row"
            [class.clickedRow]="selectedRow === row"
            (click)="clickedRow(row); expandedElement = expandedElement === row ? null : row"
            ></tr>

            <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="detail-row"
            [class.expanded-row]="expandedElement === row"
            ></tr>
      </table>
      <mat-paginator
        *ngIf="tableDataSource.filteredData.length > 0"
        [pageSize]="10"
        [pageSizeOptions]="[10, 30, 50]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
    <div
      *ngIf="dataIsLoaded && tableDataSource.filteredData.length === 0"
      class="emptyBernieContainer"
    >
      <img class="emptyBernieImg" src="../../assets/images/BernieEmptyBox.png" />
      <p class="emptyBernieText" *ngIf="tableDataSource.data.length === 0">
        {{ 'No resources found.' }}
      </p>
    </div>
  </div>
</div>
